import { lazy } from "react";
import * as XLSX from "xlsx";

export const sections = [
  {
    id: "beneficiaries",
    title: "Projeto e Beneficiário(s)",
    component: lazy(() => import("./Beneficiaries")),
  },
  {
    id: "economic",
    title: "Unidade Económica",
    component: lazy(() => import("./EconomicUnit")),
  },
  {
    id: "balance",
    title: "Balanço e DR",
    component: lazy(() => import("./BalanceDR")),
  },
  {
    id: "project",
    title: "Dados do Projeto",
    component: lazy(() => import("./ProjectData")),
  },
  {
    id: "operation",
    title: "Caracterização da Operação",
    component: lazy(() => import("./OperationDescription")),
  },
  {
    id: "economicResults",
    title: "Valorização Económica dos Resultados",
    component: lazy(() => import("./EconomicResults")),
  },
  {
    id: "innovativeFeatures",
    title: "Características Inovadoras",
    component: lazy(() => import("./InnovativeFeatures")),
  },
  {
    id: "activities",
    title: "Atividades e Indicadores",
    component: lazy(() => import("./Activities")),
  },
  {
    id: "technicians",
    title: "Pessoal técnico",
    component: lazy(() => import("./Technicians")),
  },
  { id: "team", title: "Equipa", component: lazy(() => import("./Team")) },
  { id: "costs", title: "Custos", component: lazy(() => import("./Costs")) },
  {
    id: "financing",
    title: "Financiamento",
    component: lazy(() => import("./Financing")),
  },
  {
    id: "thematic",
    title: "Enquadramento Temático",
    component: lazy(() => import("./Thematic")),
  },
  {
    id: "additions",
    title: "Majorações",
    component: lazy(() => import("./Additions")),
  },
  {
    id: "selectionCriteria",
    title: "Critérios de Seleção",
    component: lazy(() => import("./SelectionCriteria")),
  },
  {
    id: "declarations",
    title: "Declarações",
    component: lazy(() => import("./Declarations")),
  },
];

export const importFiles = {
  Mérito: (workbook, formData, jsonData, handleChange, setToast) => {
    const companyLabels = ["Líder", "Co-P2", "Co-P3", "Co-P4"];
    let companyCounter = 0;
    let enesiisCounter = 0;

    const balaceData = {};
    const drData = {};
    const financingData = {};

    formData["beneficiaries"]?.forEach((ben) => {
      const { nature, id, name } = ben;
      if (!nature) return;

      if (nature === "01") {
        // Company
        const label = companyLabels[companyCounter++];

        const balanceSheet = workbook.Sheets[`Balanço ${label}`];

        const accountsHeader = XLSX.utils
          .sheet_to_json(balanceSheet, {
            range: "B7:K7",
            header: 1,
            blankrows: false,
            defval: "",
          })[0]
          ?.map((value) => value?.toString().slice(-2));

        balaceData[id] = XLSX.utils.sheet_to_json(balanceSheet, {
          range: "B9:K71",
          blankrows: true,
          defval: "",
          skipHidden: false,
          header: accountsHeader,
        });

        const drSheet = workbook.Sheets[`DR ${label}`];
        drData[id] = XLSX.utils.sheet_to_json(drSheet, {
          range: "B5:K34",
          blankrows: true,
          defval: "",
          skipHidden: false,
          header: accountsHeader,
        });

        const financeSheet = workbook.Sheets[`Financiamento ${label}`];
        financingData[id] = XLSX.utils.sheet_to_json(financeSheet, {
          range: "K4:K22",
          blankrows: true,
          defval: "",
          skipHidden: false,
          header: ["value"],
        });
      }

      if (nature === "02") {
        // Enesii
        const financeSheet = workbook.Sheets[`Financiamento ENESII`];
        const cols = ["J", "V", "AH", "AT"];
        const currentCol = cols[enesiisCounter];

        financingData[id] = XLSX.utils.sheet_to_json(financeSheet, {
          range: `${currentCol}4:${currentCol}22`,
          blankrows: true,
          defval: "",
          skipHidden: false,
          header: ["value"],
        });

        enesiisCounter++;
      }
    });

    handleChange("balance", balaceData);
    handleChange("dr", drData);
    handleChange("financing", financingData);
    setToast({
      title: "Mérito",
      message: "Contas e Financimaneto foram carregadas com sucesso!",
      type: "success",
    });
  },
};
